import { remoteConnectionManager } from 'calling-integration-cross-tab/connectionManagement/RemoteConnectionManager';
import { OPEN_WIDGET } from 'calling-integration-cross-tab/types/BroadcastEvents';
import { useEffect } from 'react';
import { addBroadcastMessageHandler, removeBroadcastMessageHandler } from 'worker-connection-library/calling-cross-tab-utils/broadcastMessageHandler';
import { useThirdPartyWidgetDetailsContext } from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { useDispatch } from 'calling-remote-common/hooks/useDispatch';
import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
import { useBroadcastEventHandler } from 'calling-integration-cross-tab/hooks/useBroadcastEventHandler';
import { CallWidgetStates } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import { refreshIframe } from 'calling-integration-cross-tab/utils/refreshIframe';
import { InboundIframeIdSelector } from 'calling-integration-cross-tab/constants/inboundIframeSelectors';
import { useOpenWidgetDataContext } from 'calling-integration-sdk-support/viewport/contexts/OpenWidgetDataContext';
import { createBroadcastMessage } from 'calling-integration-cross-tab/messages/createBroadcastMessages';
import { sendCrossTabMessage } from 'worker-connection-library/calling-cross-tab-utils/sendCrossTabMessage';
import { useOpenCloseRemote } from './useOpenCloseRemote';
export function useRemoteConnectionManager({
  setIsPopoverMinimized
}) {
  const [, dispatch] = useThirdPartyWidgetDetailsContext();
  const {
    updateWidgetDetails,
    resetWidgetDetails,
    resetRemoteConnection
  } = useDispatch(dispatch);
  const {
    selectedCallProviderData
  } = useSelectedProviderContext();
  const {
    processCallingWindowOpenWidgetData
  } = useOpenWidgetDataContext();
  const {
    setHasThirdPartyOpened,
    openRemote
  } = useOpenCloseRemote();
  useEffect(() => {
    if (!selectedCallProviderData.usesCallingWindow) {
      return;
    }
    const conn = remoteConnectionManager;
    conn.start(payload => updateWidgetDetails(payload), resetRemoteConnection, openRemote, selectedCallProviderData.name);
    const handler = message => {
      conn.handleCrossTabMessage(message);
    };
    addBroadcastMessageHandler(handler);
    return () => {
      removeBroadcastMessageHandler(handler);
    };
  }, [resetWidgetDetails, setIsPopoverMinimized, updateWidgetDetails, selectedCallProviderData.usesCallingWindow, processCallingWindowOpenWidgetData, selectedCallProviderData, resetRemoteConnection, openRemote]);
  useBroadcastEventHandler({
    onRefreshRequest: () => {
      updateWidgetDetails({
        callStatus: CallWidgetStates.UNINITIALIZED
      });
      refreshIframe(InboundIframeIdSelector.REMOTE);
    },
    onPopupOpened: message => {
      setHasThirdPartyOpened(true);
      updateWidgetDetails({
        userAvailable: message.payload.userAvailable,
        isLoggedIn: message.payload.isLoggedIn,
        callStatus: message.payload.callStatus,
        isPopupOpen: true
      });
      const dialNumberDetails = processCallingWindowOpenWidgetData();
      if (dialNumberDetails) {
        sendCrossTabMessage(createBroadcastMessage({
          type: OPEN_WIDGET,
          payload: {
            dialNumberDetails
          }
        }));
      }
    }
  });
}